import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    contacts: [],
    contact: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
    areaOptions: [
      { value: 'Africa & Middle East', text: 'Africa & Middle East' },
      { value: 'Asia', text: 'Asia' },
      { value: 'Europe', text: 'Europe' },
      { value: 'Latin America', text: 'Latin America' },
      { value: 'North America', text: 'North America' },
      { value: 'Oceania', text: 'Oceania' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.contacts = [];
      state.contact = null;
    },
    SET_CONTACTS(state, data) {
      state.contacts = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_CONTACT(state, data) {
      state.contact = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setContact({ commit }, data) {
      commit('SET_CONTACT', data);
    },

    find({ commit, state }) {
      let url = `/contacts?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Contact'));
          return response.body;
        })
        .then((response) => {
          commit('SET_CONTACTS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/contacts/${id}`)
        .then((response) => response.body)
        .then(typeAs('Contact'))
        .then((item) => {
          commit('SET_CONTACT', item);
        });
    },

    destroy(_, id) {
      return http(`/contacts/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/contacts/${id}`, { method: 'PUT', data })
        : http('/contacts', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
